import React from 'react';
import engagementImg from "../Assets/img/enagement_img.jpg";
import weddingImg from "../Assets/img/wedding_img.jpg";
import { Link } from 'react-router-dom';

const RingType = () => {
    return (
        <section className='ring_type_section'>
            <div className='ring_type_grid'>
                <div className='grid_items'>
                    <img src={engagementImg} alt="Engagement Rings" />
                    <div className='grid_item_text'>
                        <h3>Engagement Rings</h3>
                        <p>Find your forever spark with a stunning
                            engagement ring.</p>
                        <Link to="/ringsettings">  <button className='btn outline-base-btn large'>
                            Shop Now
                        </button></Link>
                    </div>
                </div>
                <div className='grid_items'>
                    <img src={weddingImg} alt="Wedding Rings" />
                    <div className='grid_item_text'>
                        <h3>Wedding Rings</h3>
                        <p>A symbol of love, a promise for life. Explore our
                            exquisite wedding rings.</p>
                        <Link to="/jewelry/wedding-rings">
                            <button className='btn outline-base-btn large'>
                                Shop Now
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RingType